import { createContext } from 'react';
import type { NostrEvent } from '@nostrify/nostrify';

export interface MyReactionsBatchContextType {
  /**
   * Request the current user's kind-7 reaction to an event id. Calls within a
   * short window are coalesced into a single batched relay query. Resolves
   * `null` when the user has not reacted to the event.
   */
  load: (eventId: string) => Promise<NostrEvent | null>;
}

export const MyReactionsBatchContext = createContext<MyReactionsBatchContextType | undefined>(undefined);
